import { IMG1, IMG2, IMG3, IMG4, TRAINER, TRAINER3 } from './assets/images';
import TRAINER2 from './assets/66996795.jpeg';

export const TRAINERS = [
  {
    img: TRAINER,
    shortName: "Badr-Eddine",
    name: "Badr-Eddine BOUDRIKI SEMLALI",
    role: "Formateur principal",
    bio: "Expert en SIG, Télédétection et Agriculture de Précision. Formateur certifié avec une expérience terrain en Afrique et au Maroc dans l'utilisation de QGIS, Google Earth Engine et imagerie drone pour l'optimisation agricole.",
    tags: null,
    linkedin: "https://www.linkedin.com/in/badr-eddine-boudriki-semlali-b2a7bb113/",
  },
  {
    img: TRAINER2,
    shortName: "Aimad",
    name: "Aimad EL HAMMDANI",
    role: "Formateur",
    bio: "Docteur en Data Science et Intelligence Artificielle. Spécialiste en Machine Learning appliqué à l'agriculture, auteur de travaux de recherche sur la détection automatique des maladies des cultures et la prédiction du rendement par deep learning.",
    tags: ["Deep Learning", "Computer Vision", "IA Agricole", "Python"],
    linkedin: "https://www.linkedin.com/in/aimad-el-hammdani/",
  },
  {
    img: TRAINER3,
    shortName: "Nour-Eddine",
    name: "Nour-Eddine BASSA",
    role: "Formateur",
    bio: "Spécialiste SIG & WebGIS, Télédétection, Cartographie UAV et Agriculture Digitale. Basé à Casablanca-Settat, Maroc.",
    tags: ["SIG & WebGIS", "Télédétection", "Cartographie UAV", "Agriculture Digitale"],
    linkedin: "https://www.linkedin.com/in/bnoureddine123/",
  },
];

export const MODULES = [
  { num:"01", icon:"🗺️", title:"Introduction aux SIG & Télédétection en Agriculture de Précision",
    objectives:["Comprendre les principes de l'agriculture de précision","Maîtriser les bases des SIG et de la télédétection"],
    content:["Données spatiales : raster et vecteur","Indices de végétation : NDVI, NDRE, SAVI, EVI","Sources de données : satellites, drones, capteurs","Introduction aux SIG agricoles"],
    practical:["Prise en main de QGIS","Création de cartes agricoles","Calcul et interprétation d'indices de végétation"] },
  { num:"02", icon:"💧", title:"Gestion de l'Irrigation par Imagerie Drone Thermique, Multispectrale & Modélisation Agronomique",
    objectives:["Identifier le stress hydrique","Optimiser l'irrigation par zones"],
    content:["Imagerie thermique et multispectrale","Indices hydriques : NDWI, CWSI","Cartographie des zones de stress","Modélisation agronomique"],
    practical:["Analyse de données drone réelles","Cartes de stress hydrique","Plan d'irrigation différencié"] },
  { num:"03", icon:"🌿", title:"Gestion de la Fertilisation Azotée par Télédétection Satellitaire (VRA)",
    objectives:["Mettre en oeuvre la fertilisation à dose variable","Réduire les coûts et l'impact environnemental"],
    content:["Cycle de l'azote et besoins des cultures","Exploitation d'images satellitaires","Zonage agronomique","Cartes de préconisation VRA"],
    practical:["Cartes de fertilisation azotée","Simulation d'économie d'intrants","Validation agronomique"] },
  { num:"04", icon:"🛰️", title:"Suivi de la Santé des Cultures à Grande Échelle avec Google Earth Engine (GEE)",
    objectives:["Surveiller les cultures à l'échelle régionale","Automatiser le suivi agricole"],
    content:["Introduction à Google Earth Engine","Séries temporelles satellitaires","Détection précoce des anomalies","Alertes agricoles"],
    practical:["Scripts GEE agricoles","Monitoring NDVI multi-années","Cartes de stress et d'anomalies"] },
  { num:"05", icon:"🤖", title:"Détection des Maladies des Cultures par Imagerie Drone, SIG et IA",
    objectives:["Identifier les maladies à un stade précoce","Appuyer la décision phytosanitaire"],
    content:["Machine Learning et Deep Learning","Signatures spectrales des maladies","Segmentation des zones malades","Intégration SIG"],
    practical:["Entraînement d'un modèle de classification","Cartes de probabilité de maladies","Recommandations phytosanitaires"] },
  { num:"06", icon:"📊", title:"Estimation du Rendement Agricole par SIG, IA et Données Multi-Sources",
    objectives:["Prédire le rendement agricole","Améliorer la planification et la commercialisation"],
    content:["Facteurs influençant le rendement","Données : sol, climat, satellite, drone","Modèles statistiques et IA","Calibration des modèles"],
    practical:["Modèle de prédiction du rendement","Cartographie du rendement estimé","Analyse des résultats"] },
];

export const PROOF = [
  { src:IMG1, caption:"Analyse drone multispectrale sur QGIS — Session live avec apprenants", tag:"QGIS · Drone MS" },
  { src:IMG2, caption:"Zonage de précision avec Pix4Dfields — NDVI par zones de management", tag:"Pix4Dfields · Zonage" },
  { src:IMG3, caption:"Cartographie NDVI par parcelles — Statistiques zonales en temps réel", tag:"NDVI · Statistiques" },
  { src:IMG4, caption:"Session live avec +13 participants de 5 pays africains", tag:"Live · Afrique" },
];

export const SKILLS = [
  "SIG agricole avancé (QGIS, ArcGIS, GEE)",
  "Analyse d'images satellites et drones",
  "Agriculture de précision orientée DATA",
  "Cartes de recommandations VRA",
  "Détection des maladies par IA",
  "Prédiction du rendement agricole",
];

export const TESTIMONIALS = [
  {
    name: "Aminata Diallo",
    role: "Ingénieure Agronome",
    country: "Sénégal",
    flag: "🇸🇳",
    initials: "AD",
    color: "#0F6E56",
    stars: 5,
    text: "Avant cette formation, je prenais mes décisions d'irrigation à l'œil. Aujourd'hui je cartographie chaque parcelle avec QGIS et j'ai réduit ma consommation d'eau de 28%. Le retour sur investissement a été immédiat dès la première saison.",
  },
  {
    name: "Mohammed Koné",
    role: "Gérant d'exploitation · 450 ha",
    country: "Côte d'Ivoire",
    flag: "🇨🇮",
    initials: "MK",
    color: "#085041",
    stars: 5,
    text: "La formation est ultra-pratique. Dès le module 2, j'appliquais l'imagerie drone thermique sur mes cultures de cacao. Les formateurs répondent à chaque question avec des exemples concrets d'Afrique. Exactement ce qu'il nous faut.",
  },
  {
    name: "Fatima Zohra Benmoussa",
    role: "Consultante agricole",
    country: "Maroc",
    flag: "🇲🇦",
    initials: "FB",
    color: "#1D9E75",
    stars: 5,
    text: "Le module Google Earth Engine a transformé ma façon de travailler. Je livre maintenant des rapports de monitoring satellitaire à mes clients en quelques heures là où ça prenait des semaines. Mon tarif a doublé.",
  },
  {
    name: "Ibrahim Ouédraogo",
    role: "Technicien agricole — ONG",
    country: "Burkina Faso",
    flag: "🇧🇫",
    initials: "IO",
    color: "#EF9F27",
    stars: 5,
    text: "En tant que technicien dans une ONG, j'avais besoin d'outils accessibles et puissants. QGIS + GEE m'ont permis de produire des cartes de risque alimentaire pour 3 régions. Le certificat m'a aussi ouvert des portes pour des projets FAO.",
  },
  {
    name: "Nadia Benali",
    role: "Chercheuse en agronomie",
    country: "Tunisie",
    flag: "🇹🇳",
    initials: "NB",
    color: "#04342C",
    stars: 5,
    text: "Le module IA agricole dépasse tout ce que j'avais vu en formation académique. J'ai pu entraîner un modèle de détection des maladies sur mes propres données de terrain. Une formation qui mérite largement son certificat international.",
  },
];

export const PRICING = [
  { key: "MAD", region: "Maroc", price: "1 300 MAD" },
  { key: "CFA", region: "Afrique subsaharienne", price: "84 000 FCFA" },
  { key: "USD", region: "International", price: "130 USD" },
];

export const PAYMENT_METHODS = [
  {
    countries: ["Sénégal", "Mali", "Mauritanie"],
    flag: "🇸🇳",
    contact: "Ababacar Ba — Business Manager (Dakar)",
    methods: [{ label: "Wave / Orange Money", value: "+221 77 840 99 69" }],
  },
  {
    countries: ["Côte d'Ivoire", "Burkina Faso"],
    flag: "🇨🇮",
    contact: "M. Zoumana Diomandé — Business Manager (Abidjan)",
    methods: [{ label: "Wave / Orange Money", value: "07 59 32 05 63" }],
  },
  {
    countries: ["Guinée Conakry"],
    flag: "🇬🇳",
    contact: "Diallo Ibrahima",
    methods: [{ label: "Orange Money", value: "+224 614 938 452" }],
  },
  {
    countries: ["Cameroun"],
    flag: "🇨🇲",
    contact: "Kuekou SANGFOU Stalin",
    methods: [
      { label: "Orange Money", value: "696 94 00 12" },
      { label: "MTN Mobile Money", value: "673 70 96 87" },
      { label: "IBAN — CCA Bank", value: "100260075756720111" },
      { label: "IBAN — Afriland First Bank", value: "CM21 10005 00001 07244731051-06" },
    ],
  },
  {
    countries: ["Tchad"],
    flag: "🇹🇩",
    contact: "M. Demba Mathias Kodindo",
    methods: [{ label: "Airtel Money", value: "+235 66 15 47 81" }],
  },
  {
    countries: ["Togo", "Bénin", "RDC (Kinshasa)", "Congo (Brazzaville)", "Autre pays"],
    flag: "🌍",
    contact: "BASSA Noureddine — Maroc",
    methods: [{ label: "Western Union / RIA / MoneyGram", value: "+212 658 770 092" }],
  },
];

export const FAQ = [
  {
    q: "Est-ce en ligne ou en présentiel ?",
    a: "100% en ligne, en direct (live) via Zoom. Toutes les sessions sont enregistrées et accessibles pendant 6 mois. Vous pouvez suivre depuis n'importe quel pays africain ou européen.",
  },
  {
    q: "Faut-il déjà connaître QGIS ou la télédétection ?",
    a: "Non. Le certificat est conçu pour les agronomes, ingénieurs et techniciens agricoles sans expérience préalable en SIG. Le module 1 part de zéro. Un ordinateur et une connexion internet suffisent.",
  },
  {
    q: "Puis-je payer en plusieurs fois ?",
    a: "Oui. Nous proposons un paiement en 2 ou 3 fois sans frais. Les modalités exactes vous sont communiquées après votre inscription. Virement, carte bancaire et Mobile Money acceptés.",
  },
  {
    q: "Quelle est la durée totale de la formation ?",
    a: "6 semaines intensives à raison de 2 à 3 sessions live par semaine. Comptez environ 4 à 6 heures de travail par semaine, sessions + exercices pratiques inclus.",
  },
  {
    q: "Le certificat est-il reconnu officiellement ?",
    a: "Oui. Le Certificat Exécutif est délivré par AgriTech Academy · AITAI, reconnu par nos partenaires institutionnels dans 13+ pays africains. Il est accompagné d'un badge numérique partageable sur LinkedIn.",
  },
  {
    q: "Que se passe-t-il après mon inscription ?",
    a: "Notre équipe vous contacte sous 24h avec le programme détaillé en PDF, les dates exactes, le lien de paiement et les prérequis techniques (logiciels à installer). Zéro engagement à ce stade.",
  },
];

